// extracted by mini-css-extract-plugin
module.exports =  {"container":"container__nQXsQ","title":"title__6o3ZH","description":"description__lUJHX"};